<template>
  <div v-bind:class="$_class">
    <v-slider
      dense
      hide-details
      thumb-size="24"
      v-model="$data.$_internalCefrScore"
      v-bind:vertical="isVertical"
      v-bind:color="$_color"
      v-bind:thumb-label="$_thumbLabel"
      v-bind:max="$_internalCefrScoreMax"
      v-bind:step="1"
      v-bind:tick-labels="$_cefrScoreClassNameArray"
      v-bind:disabled="$_disabled"
      v-on:end="$_onCefrScoreChanged"
      v-on:mousedown="$_onSliderTouched"
      v-on:change="$_onSliderTouched"
      v-on:click.stop
    >
      <template v-slot:thumb-label="{ value: externalCefrScore }">
        <slot name="thumb-label">{{ $_thumbLabelText(externalCefrScore) }}</slot>
      </template>
    </v-slider>

    <v-overlay absolute v-if="isUnratable || isHidden">
      <template v-if="isUnratable">Unratable</template>
      <template v-else-if="isHidden">Hidden</template>
    </v-overlay>
  </div>
</template>

<style scoped>
.cefr-score-editor-slider-horizontal,
.cefr-score-editor-slider-vertical {
  position: relative;
}

.cefr-score-editor-slider-horizontal {
  width: 100%;
}

.cefr-score-editor-slider-vertical {
  position: relative;
  min-height: 200px;
  width: 32px;
}

.cefr-score-editor-slider-vertical,
.cefr-score-editor-slider-vertical >>> .v-slider,
.cefr-score-editor-slider-vertical >>> .v-input,
.cefr-score-editor-slider-vertical >>> .v-input__control,
.cefr-score-editor-slider-vertical >>> .v-input__slot {

  height: 100%;
}

.cefr-score-editor-slider-vertical >>> .v-overlay {
  writing-mode: vertical-rl;
}

</style>

<script>
import { TimelineSegmentId } from '@Scatt'
import cefrScoreClassUtils from './cefrScoreClassUtils.js'

/*
function generateScoreClassNameArray() {
  let scoreClassNameArray = [];
  cefrScoreClassUtils.classNameArray.forEach((className, idx) => {
    scoreClassNameArray.push(className);
    if (idx !== (cefrScoreClassUtils.numClasses - 1)) {
      scoreClassNameArray.push('', '');
    }
  });
  return scoreClassNameArray;
}

const cefrScoreClassNameArray = generateScoreClassNameArray();
*/
const cefrScoreClassNameArray = cefrScoreClassUtils.classNameArray;
const internalCefrScoreMax = cefrScoreClassNameArray.length - 1;
const scoreToInternalScoreScalingFactor = internalCefrScoreMax / cefrScoreClassUtils.scoreMax;

export default {
  model: {
    prop: 'externalCefrScore',
    event: 'update',
  },

  watch: {
    externalCefrScore: {
      handler(newExternalCefrScore) {
        if (this.isHidden) newExternalCefrScore = null;
        this.$data.$_isTouched = (newExternalCefrScore !== null);
        if (newExternalCefrScore !== null) {
          this.$_updateInternalScore(newExternalCefrScore)
        }
      },
      immediate: true,
    },
  },

  props: {
    isUnratable: { type: Boolean },
    externalCefrScore: { type: Number },
    cefrScoreTimelineSegmentId: { type: TimelineSegmentId },
    isVertical: { type: Boolean, default: false },
    isHidden: { type: Boolean, default: false },
  },

  data() {
    return {
      $_internalCefrScore: null,
      $_isTouched: false,
    };
  },

  computed: {
    $_internalCefrScoreMax() { return internalCefrScoreMax; },
    $_cefrScoreClassNameArray() { return cefrScoreClassNameArray; },
    $_color() { return ((this.$data.$_isTouched) ? undefined : 'transparent') },
    $_thumbLabel() { return ((this.$data.$_isTouched)? 'always' : false) },
    $_disabled() { return (this.isUnratable || this.isHidden) },
    $_class() { return ((this.isVertical)? [ 'cefr-score-editor-slider-vertical' ] : [ 'cefr-score-editor-slider-horizontal' ]) },
  },

  methods: {
    /* private */
    $_updateInternalScore(externalCefrScore) {
      this.$data.$_internalCefrScore = externalCefrScore * scoreToInternalScoreScalingFactor;
    },

    $_onCefrScoreChanged(internalCefrScore) {
      let newExternalCefrScore = internalCefrScore / scoreToInternalScoreScalingFactor;
      this.$emit('update', newExternalCefrScore);
    },

    $_thumbLabelText(internalCefrScore) {
      let externalCefrScore = internalCefrScore / scoreToInternalScoreScalingFactor;
      return cefrScoreClassUtils.convertCefrScoreToClassDetailed(externalCefrScore);
    },

    $_onSliderTouched() {
      this.$data.$_isTouched = true;
      this.$emit('touched');
    },
  },
};
</script>